import { Footer } from '@/previewThemes/feast/Footer';
import { Header } from '@/previewThemes/feast/Header';
import { Product } from '@/previewThemes/feast/Product';
import { FEAST_PRESETS } from '@/previewThemes/feast/presets';
import type { ThemePackage } from '@/previewThemes/types';

export const theme: ThemePackage = {
  Header,
  Footer,
  Product,
  // See `presets.ts`: this theme's own shelf of the add-section library,
  // which is arrangement and copy rather than any new kind of section.
  presets: FEAST_PRESETS,
  listing: {
    // Four across beside the filter rail, with a tall row gap: the cards here
    // carry no border and no fill, so the only thing separating one row from
    // the next is the space under the price.
    grid: 'grid-cols-2 gap-x-6 gap-y-12 md:grid-cols-3 xl:grid-cols-4',
    // A shop of fourteen shelves sold in colourways is narrowed on three axes
    // at once - shelf, colour and price - and a row of chips cannot hold that.
    filters: 'sidebar',
    columns: 4,
    // The plain card: a square picture on the surface colour, the name under
    // it, the price under that. Nothing is drawn around a tile in this theme -
    // see the square corners in `meta.ts`, which are the frames the range is
    // photographed against.
    card: 'standard',
  },
  // Outlined, never filled: the surface colour here is a hair off white and a
  // filled panel would read as a rendering fault rather than as a panel.
  cart: { grid: 'mt-10 grid gap-12 lg:grid-cols-3', panel: 'outlined' },
  checkout: {
    grid: 'mt-10 grid items-start gap-12 lg:grid-cols-[minmax(0,1fr)_26rem]',
    panel: 'outlined',
  },
  search: {
    grid: 'mt-10 grid gap-12 lg:grid-cols-[240px_1fr]',
    results: 'grid grid-cols-2 gap-x-6 gap-y-12 lg:grid-cols-3 xl:grid-cols-4',
    columns: 4,
    card: 'standard',
    panel: 'bare',
  },
  blog: { list: 'grid gap-10 sm:grid-cols-2 lg:grid-cols-3', title: 'text-xl' },
  // Seven across, which is the row the home page opens on and the row this
  // theme's page width was chosen for.
  category: { grid: 'grid gap-6 sm:grid-cols-3 lg:grid-cols-7', tile: 'card' },
  // What this theme used to write on `BuyBox` and `ProductGallery` by hand.
  // The merchant's components read it wherever they have left a setting at
  // "the theme's own", which is where every shop starts - so a shop nobody
  // has arranged renders the product page this theme has always drawn.
  parts: {
    product_details: {
      presentation: {
        classes: { product_title: 'text-3xl sm:text-4xl' },
        wideButtons: true,
        gallery: { rounded: false },
      },
    },
  },
};
